var map = {
	"./icons/add.svg": 655,
	"./icons/analysis.svg": 656,
	"./icons/del.svg": 657,
	"./icons/download.svg": 658,
	"./icons/edit.svg": 659,
	"./icons/menuDown.svg": 660,
	"./icons/menuUp.svg": 661,
	"./icons/score.svg": 662,
	"./icons/vector.svg": 663,
	"./topic/address.svg": 664,
	"./topic/annotation-more.svg": 665,
	"./topic/annotation.svg": 666,
	"./topic/comment.svg": 667,
	"./topic/history-record.svg": 668,
	"./topic/relate-info.svg": 669,
	"./topic/relation-info.svg": 670,
	"./topic/relation.svg": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 654;